import React, { Fragment } from "react";
import Search from "@material-ui/icons/Search";
import Input from "components/General/Form/Input";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import TextTheme from "components/General/Text/TextTheme";

class InviteFriends extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      friendName: "",
      friendEmail: "",
      searchStatus: "",
    };
  }

  onFriendNameChange(e) {
    this.setState({ friendName: e.target.value });
    this.setState({ friendEmail: "" });
    this.setState({ searchStatus: "" });
  }

  onFriendEmailChange(e) {
    this.setState({ friendEmail: e.target.value });
    this.setState({ friendName: "" });
    this.setState({ searchStatus: "" });
  }

  onSearchFriends(e) {
    if (this.state.friendName) {
      this.props.searchResultHandler(["name", this.state.friendName]);
    } else if (this.state.friendEmail) {
      let emailValid = this.state.friendEmail.match(
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
      );
      if (emailValid === null) {
        this.setState({ searchStatus: "Invalid Email Id" });
      } else {
        this.props.searchResultHandler(["email", this.state.friendEmail]);
      }
    } else {
      this.setState({ searchStatus: "Enter some value to search by" });
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.showHeaderMessage ? (
          // <TextTheme
          //   message="BUILD YOUR TEAM"
          //   className="text_large text_dark_blue"
          // />
          <div className="project-details">
            <div className="insideContent">
              <h3 className="textHeader">STEP 4 : BUILD YOUR TEAM</h3>
            </div>
          </div>
        ) : null}
        <hr />
        <TextTheme
          message={this.props.message}
          className="mt-15 text_small text_black"
        />
        <div className="mt-15 invite-friend">
          <TextTheme
            message="Find friends by their name : "
            className="text_small text_black"
          />
          <Input
            name="friendName"
            autoComplete={"" + Math.random()}
            type="text"
            id="friend-name"
            placeholder="Enter Name"
            value={this.state.friendName}
            handleChange={this.onFriendNameChange.bind(this)}
          />
        </div>

        <div className="mt-15 mb-15 invite-friend">
          <TextTheme
            message="Find friends by their email : "
            className="text_small text_black"
          />
          <Input
            name="friendEmail"
            autoComplete={"" + Math.random()}
            type="text"
            id="friend-emailid"
            placeholder="Enter Email"
            value={this.state.friendEmail}
            handleChange={this.onFriendEmailChange.bind(this)}
          />
        </div>

        <TextTheme
          message={this.state.searchStatus}
          className="mt-15 mb-15 text-center text_red text_small"
        />
        <RoundedButton
          startIcon={<Search style={{ fontSize: 30, color: "#fff" }} />}
          handleOnClick={this.onSearchFriends.bind(this)}
          disabled={this.props.disabled}
          title="SEARCH&nbsp;"
          textThemeClassName="text_medium text_white"
          buttonClassName="background_dark_orange"
        />
      </Fragment>
    );
  }
}

export default InviteFriends;
